import ApiService from '../apiservice'

export default class CalculoTipoContribuicaoService extends ApiService {
  constructor() {
    super('/calculo-tempo-contribuicao')
  }

  cadastrar(calculo) {
    return this.post('/',calculo);
  }

  consultarPorPessoa(pessoaId) {
    return this.get(`/consultar-por-pessoa/${pessoaId}`);
  }

  consultar(codigo) {
    return this.get(`/${codigo}`);
  }

  alterar(calculo) {
    return this.put('/',calculo);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }

  calcularTempo(calculo) {
    return this.post('/calcular-tempo',calculo);
  }
}